// extracted by mini-css-extract-plugin
module.exports = {"sectionHeading":"editor_sectionHeading__2H12k"};